export enum ConversationCommentStatus {
  NoComments = 1,
  CommentedByMe = 2,
  CommentedByOthers = 3,
}
